export const imagesArr = [
  // 加载页
  require("../img/loading_bg.jpg"),
  require("../img/icon_loading.png"),
  require("../img/logo.png"),
  // 首页
  require("../img/index_bg.jpg"),
  require("../img/earth.jpg"),
  require("../img/moon.jpg"),
  require("../img/earth-bump.jpg"),
  require("../img/theme.png"),
  require("../img/roll_tips.png"),
  require("../img/roll_arrow.png"),
  require("../img/cloud.png"),
  require("../img/hand.png"),
  require("../img/cover_layer.png"),
  require("../img/start_btn.png"),
];
